import React from 'react';

export default class ResponsiveTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            itemsPerPage: 10,
            selectedRows: []
        };
    }

    componentDidMount() {
        if (this.props.selectedRows) {
            this.setState({ selectedRows: this.props.selectedRows });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedRows && prevProps.selectedRows !== this.props.selectedRows) {
            this.setState({ selectedRows: this.props.selectedRows || [] });
        }
        // Si cambia el conjunto de datos (nueva búsqueda), volver a la primera
        // página para no quedar en una página que ya no existe.
        if (prevProps.data !== this.props.data && this.state.currentPage !== 1) {
            this.setState({ currentPage: 1 });
        }
    }

    handlePageChange = (page) => {
        this.setState({ currentPage: page });
    }

    handleItemsPerPageChange = (itemsPerPage) => {
        this.setState({ 
            itemsPerPage: parseInt(itemsPerPage),
            currentPage: 1 
        });
    }

    handleRowSelect = (row) => {
        // Nunca mutar el arreglo recibido por props (es el estado del padre):
        // siempre producir una referencia nueva.
        const current = this.state.selectedRows || [];
        const newSelectedRows = current.find(item => item.idHeaderFine === row.idHeaderFine)
            ? current.filter(item => item.idHeaderFine !== row.idHeaderFine)
            : [...current, row];
        this.setState({ selectedRows: newSelectedRows }, () => {
            if (this.props.onRowSelectionChange) {
                this.props.onRowSelectionChange(newSelectedRows);
            }
        });
    }

    handleSelectAll = (isSelected) => {
        const { data } = this.props;
        const { currentPage, itemsPerPage } = this.state;
        
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentPageData = data.slice(startIndex, endIndex);
        
        const selectableRows = currentPageData.filter(row => row.isCheckbox === true);
        
        let newSelectedRows = [...this.state.selectedRows];
        
        if (isSelected) {
            selectableRows.forEach(row => {
                if (!newSelectedRows.find(item => item.idHeaderFine === row.idHeaderFine)) {
                    newSelectedRows.push(row);
                }
            });
        } else {
            selectableRows.forEach(row => {
                newSelectedRows = newSelectedRows.filter(item => item.idHeaderFine !== row.idHeaderFine);
            });
        }
        
        this.setState({ selectedRows: newSelectedRows }, () => {
            if (this.props.onRowSelectionChange) {
                this.props.onRowSelectionChange(newSelectedRows);
            }
        });
    }

    renderStatusBadge = (status) => {
        const statusClasses = {
            'PENDIENTE POR PAGAR': 'bg-red-100 text-red-800',
            'PAGO PARCIAL': 'bg-yellow-100 text-yellow-800',
            'PAGADA': 'bg-green-100 text-green-800',
            'MOROSIDAD': 'bg-orange-100 text-orange-800',
            'LLAMADO DE ATENCIÓN': 'bg-gray-100 text-gray-800'
        };

        const displayText = {
            'PENDIENTE POR PAGAR': 'PENDIENTE POR PAGAR',
            'PAGO PARCIAL': 'PAGO PARCIAL',
            'PAGADA': 'PAGADA',
            'MOROSIDAD': 'MOROSA',
            'REVOCACIÓN': 'REVOCADA'
        };

        return (
            <span className={`inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ${statusClasses[status] || 'bg-gray-100 text-gray-800'}`}>
                {displayText[status] || status}
            </span>
        );
    }

    formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    }

    render() {
        const { data, columns, withCheckbox, onRowClick, renderActions } = this.props;
        const { currentPage, itemsPerPage, selectedRows } = this.state;

        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentPageData = data.slice(startIndex, endIndex);
        const totalPages = Math.ceil(data.length / itemsPerPage);

        const selectableCurrentPageData = currentPageData.filter(row => row.isCheckbox === true);
        
        const allCurrentPageSelected = selectableCurrentPageData.length > 0 && 
            selectableCurrentPageData.every(row => selectedRows.find(item => item.idHeaderFine === row.idHeaderFine));

        return (
            <div className="w-full">
                <div className="hidden lg:block overflow-x-auto">
                    <div className="min-w-full bg-white shadow-sm ring-1 ring-gray-200 rounded-lg">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                {<tr>
                                    {withCheckbox && (
                                        <th className="px-6 py-3 text-left">
                                            Seleccionar
                                        </th>
                                    )}
                                    {columns.map((column, index) => (
                                        <th
                                            key={index}
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            {column.headerName}
                                        </th>
                                    ))}
                                    {renderActions && (
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Acciones
                                        </th>
                                    )}
                                </tr>}
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {currentPageData.map((row, index) => {
                                    const isSelected = selectedRows.find(item => item.idHeaderFine === row.idHeaderFine);
                                    return (
                                        <tr
                                            key={row.idHeaderFine || index}
                                            className={`hover:bg-gray-50 cursor-pointer ${isSelected ? 'bg-blue-50' : ''}`}
                                            onClick={(e) => {
                                                if (e.target.type !== 'checkbox' && e.target.type !== 'button' && !e.target.closest('button') && onRowClick) {
                                                    onRowClick(row);
                                                }
                                            }}
                                        >
                                            {withCheckbox && row.isCheckbox && (
                                                <td className="px-6 py-4 whitespace-nowrap" onClick={(e) => e.stopPropagation()}>
                                                    <input
                                                        type="checkbox"
                                                        checked={!!isSelected}
                                                        onChange={(e) => {
                                                            this.handleRowSelect(row, e.target.checked);
                                                        }}
                                                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                    />
                                                </td>
                                            )}
                                            {withCheckbox && !row.isCheckbox && (
                                                <td className="px-6 py-4 whitespace-nowrap" onClick={(e) => e.stopPropagation()}>
                                                </td>
                                            )}
                                            {columns.map((column, colIndex) => (
                                                <td key={colIndex} className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                    {column.renderCell ? 
                                                        column.renderCell({row, field: column.field}) :
                                                        column.field === 'descripStatus' ? 
                                                        this.renderStatusBadge(row[column.field]) :
                                                        column.field === 'dateReg' ?
                                                        this.formatDate(row[column.field]) :
                                                        column.field === 'totalBS' || column.field === 'remainder' ?
                                                        `Bs. ${row[column.field]}` :
                                                        row[column.field]
                                                    }
                                                </td>
                                            ))}
                                            {renderActions && (
                                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" onClick={(e) => e.stopPropagation()}>
                                                    {renderActions(row)}
                                                </td>
                                            )}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="lg:hidden space-y-4">
                    {currentPageData.map((row, index) => {
                        const isSelected = selectedRows.find(item => item.idHeaderFine === row.idHeaderFine);
                        return (
                            <div
                                key={row.idHeaderFine || index}
                                className={`bg-white shadow-sm ring-1 ring-gray-200 rounded-lg p-4 ${isSelected ? 'ring-blue-500 bg-blue-50' : ''}`}
                                onClick={(e) => {
                                    if (e.target.type !== 'checkbox' && e.target.type !== 'button' && onRowClick) {
                                        onRowClick(row);
                                    }
                                }}
                            >
                                <div className="flex items-start justify-between">
                                    <div className="flex-1 min-w-0">
                                        <div className="flex items-center space-x-2 mb-2">
                                            {withCheckbox && row.isCheckbox && (
                                                <input
                                                    type="checkbox"
                                                    checked={!!isSelected}
                                                    onChange={(e) => {
                                                        e.stopPropagation();
                                                        this.handleRowSelect(row, e.target.checked);
                                                    }}
                                                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                />
                                            )}
                                            <h3 className="text-sm font-medium text-gray-900 truncate">
                                                {row.fullnameUser || row.identification || row.paymentFromDescrip || 'Registro'}
                                            </h3>
                                        </div>
                                        
                                        <div className="grid grid-cols-1 gap-2 text-xs text-gray-500">
                                            {columns.slice(0, 4).map((column, colIndex) => (
                                                <div key={colIndex}>
                                                    <span className="font-medium">{column.headerName}:</span> {
                                                        column.renderCell ? 
                                                            column.renderCell({row, field: column.field}) :
                                                            column.field === 'descripStatus' ? 
                                                            this.renderStatusBadge(row[column.field]) :
                                                            column.field === 'dateReg' ?
                                                            this.formatDate(row[column.field]) :
                                                            column.field === 'totalBS' || column.field === 'remainder' || column.field === 'amount' ?
                                                            `Bs. ${row[column.field]}` :
                                                            column.field === 'amountEurLocal' ?
                                                            `€ ${row[column.field]}` :
                                                            row[column.field] || 'N/A'
                                                    }
                                                </div>
                                            ))}
                                        </div>
                                        
                                        {columns.length > 4 && (
                                            <div className="mt-2 grid grid-cols-1 gap-2 text-xs text-gray-500">
                                                {columns.slice(4).map((column, colIndex) => (
                                                    <div key={colIndex + 4}>
                                                        <span className="font-medium">{column.headerName}:</span> {
                                                            column.renderCell ? 
                                                                column.renderCell({row, field: column.field}) :
                                                                column.field === 'descripStatus' ? 
                                                                this.renderStatusBadge(row[column.field]) :
                                                                column.field === 'dateReg' ?
                                                                this.formatDate(row[column.field]) :
                                                                column.field === 'totalBS' || column.field === 'remainder' || column.field === 'amount' ?
                                                                `Bs. ${row[column.field]}` :
                                                                column.field === 'amountEurLocal' ?
                                                                `€ ${row[column.field]}` :
                                                                row[column.field] || 'N/A'
                                                        }
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    
                                    {renderActions && (
                                        <div className="ml-4 flex-shrink-0">
                                            {renderActions(row)}
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>

                {data.length > 0 && (
                    <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
                        <div className="flex-1 flex justify-between sm:hidden">
                            <button
                                onClick={() => this.handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                                className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                Anterior
                            </button>
                            <button
                                onClick={() => this.handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                                className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                Siguiente
                            </button>
                        </div>
                        
                        <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                            <div>
                                <p className="text-sm text-gray-700">
                                    Mostrando{' '}
                                    <span className="font-medium">{startIndex + 1}</span>
                                    {' '}a{' '}
                                    <span className="font-medium">{Math.min(endIndex, data.length)}</span>
                                    {' '}de{' '}
                                    <span className="font-medium">{data.length}</span>
                                    {' '}resultados
                                </p>
                            </div>
                            
                            <div className="flex items-center space-x-2">
                                <select
                                    value={itemsPerPage}
                                    onChange={(e) => this.handleItemsPerPageChange(e.target.value)}
                                    className="border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                >
                                    <option value={5}>5 por página</option>
                                    <option value={10}>10 por página</option>
                                    <option value={25}>25 por página</option>
                                    <option value={50}>50 por página</option>
                                </select>
                                
                                <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px">
                                    <button
                                        onClick={() => this.handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                        className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        <span className="sr-only">Anterior</span>
                                        <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                                        </svg>
                                    </button>
                                    
                                    {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                        // Ventana deslizante de 5 páginas centrada en la actual.
                                        const start = Math.max(1, Math.min(currentPage - 2, totalPages - 4));
                                        const page = start + i;
                                        return (
                                            <button
                                                key={page}
                                                onClick={() => this.handlePageChange(page)}
                                                className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${
                                                    currentPage === page
                                                        ? 'z-10 bg-blue-50 border-blue-500 text-blue-600'
                                                        : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'
                                                }`}
                                            >
                                                {page}
                                            </button>
                                        );
                                    })}
                                    
                                    <button
                                        onClick={() => this.handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                        className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        <span className="sr-only">Siguiente</span>
                                        <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                                        </svg>
                                    </button>
                                </nav>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
